import { useState } from 'react';

const TestimonialSection = () => {
  const testimonials = [
    {
      quote: "GrowthLink transformed our digital presence completely. Their strategic approach to SEO and content marketing helped us achieve a 300% increase in organic traffic within just six months.",
      name: "Dr Sushma",
      company: "Siya Dental",
      avatar: "https://readdy.ai/api/search-image?query=professional%20business%20woman%20executive%20with%20confident%20smile%20wearing%20elegant%20business%20attire%20in%20modern%20corporate%20office%20setting%20with%20natural%20lighting%20and%20clean%20neutral%20background&width=120&height=120&seq=test1&orientation=squarish",
    },
    {
      quote: "Working with GrowthLink has been a game-changer for our business. Their PPC campaigns delivered exceptional ROI, and their team's expertise in social media marketing helped us build a loyal community.",
      name: "Ajit Sharma",
      company: "Innovate Solutions",
      avatar: "https://readdy.ai/api/search-image?query=professional%20business%20man%20executive%20with%20friendly%20expression%20wearing%20modern%20business%20casual%20attire%20in%20contemporary%20office%20environment%20with%20soft%20lighting%20and%20minimal%20background&width=120&height=120&seq=test2&orientation=squarish",
    },
    {
      quote: "The team at GrowthLink truly understands digital marketing. Their data-driven approach and creative strategies helped us double our conversion rates and significantly reduce our customer acquisition costs.",
      name: "Neha Shetty",
      company: "Global Ventures",
      avatar: "https://readdy.ai/api/search-image?query=professional%20businesswoman%20leader%20with%20warm%20smile%20wearing%20professional%20attire%20in%20bright%20modern%20workspace%20with%20clean%20aesthetic%20and%20neutral%20toned%20background&width=120&height=120&seq=test3&orientation=squarish",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const current = testimonials[currentIndex];

  return (
    <section className="py-32 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        {/* Section Title */}
        <h2 className="text-5xl font-bold text-dark text-center mb-16">
          Client Success Stories
        </h2>

        {/* Rating Badge */}
        <div className="flex justify-center mb-12">
          <div className="bg-dark px-8 py-3 rounded-full flex items-center gap-3">
            <i className="ri-star-fill text-yellow-400 text-xl"></i>
            <span className="text-white font-bold text-lg">4.9</span>
          </div>
        </div>

        {/* Testimonial Content */}
        <div className="text-center space-y-8 mb-12">
          <div className="relative">
            <i className="ri-double-quotes-l text-6xl text-primary/20 absolute -top-4 -left-4"></i>
            <p className="text-4xl font-serif text-gray-800 leading-relaxed max-w-4xl mx-auto relative z-10">
              {current.quote}
            </p>
            <i className="ri-double-quotes-r text-6xl text-primary/20 absolute -bottom-4 -right-4"></i>
          </div>

          {/* Client Info */}
          <div className="flex flex-col items-center gap-4 pt-8">
            <div className="w-20 h-20 rounded-full overflow-hidden border-4 border-primary/20">
              <img
                src={current.avatar}
                alt={current.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <div className="text-xl font-bold text-dark">{current.name}</div>
              <div className="text-base text-gray-600">{current.company}</div>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <div className="flex justify-center gap-4">
          <button
            onClick={handlePrev}
            className="w-12 h-12 flex items-center justify-center border-2 border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Previous testimonial"
          >
            <i className="ri-arrow-left-line text-xl text-dark"></i>
          </button>
          <button
            onClick={handleNext}
            className="w-12 h-12 flex items-center justify-center bg-dark rounded-lg hover:bg-primary transition-colors"
            aria-label="Next testimonial"
          >
            <i className="ri-arrow-right-line text-xl text-white"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
